export default __webpack_public_path__ + "static/media/17.87af0de0.png";